import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CustomButton from "../Buttons/Button";
import { configurePurification } from "../../store/actions/stocks/configurePurification";

function ConfigureStockPurificationModal({ open, onClose, stock }) {
  const dispatch = useDispatch();
  const loading = useSelector(
    (state) => state?.stocks?.configurePurificationPending
  );
  const [purificationRequired, setPurificationRequired] = useState(false);
  const [purificationRate, setPurificationRate] = useState("");

  useEffect(() => {
    if (open) {
      setPurificationRequired(Boolean(stock?.purification_required));
      setPurificationRate(stock?.purification_rate ?? "");
    }
  }, [open, stock]);

  const handleSubmit = () => {
    if (purificationRequired && purificationRate === "") {
      toast.error("Please enter a purification rate.");
      return;
    }

    dispatch(
      configurePurification({
        id: stock?.id,
        data: {
          purification_required: purificationRequired,
          purification_rate: Number(purificationRate) || 0,
        },
        callback: onClose,
      })
    );
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 480,
          maxWidth: "92%",
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{ position: "absolute", top: 19, right: 10 }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full p-3">
          <h1 className="font-semibold text-2xl mb-1">Configure Purification</h1>
          <p className="text-sm mb-6 text-[#475467]">
            Set the purification requirement and rate for{" "}
            {stock?.symbol || "this stock"}.
          </p>

          <div className="flex items-center justify-between mb-4">
            <label className="text-sm font-[500]">Purification Required</label>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={purificationRequired}
                onChange={(e) => setPurificationRequired(e.target.checked)}
              />
              <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#159AA8]"></div>
            </label>
          </div>

          <label className="text-sm font-[500]">Purification Rate (%)</label>
          <input
            type="number"
            value={purificationRate}
            onChange={(e) => setPurificationRate(e.target.value)}
            placeholder="Enter purification rate"
            disabled={!purificationRequired}
            className="w-full border border-[#D0D5DD] rounded-lg p-3 mt-1 mb-4 outline-none disabled:bg-[#F9FAFB] disabled:cursor-not-allowed"
          />

          <div className="flex mt-2 w-full items-center">
            <CustomButton
              variant="outlined"
              customColor="#fff"
              children="Cancel"
              width="100%"
              height="44px"
              borderColor="#D0D5DD"
              color="#344054"
              margin="0px 25px 0px 0px"
              onClick={onClose}
            />
            <CustomButton
              variant="contained"
              customColor="#159AA8"
              children="Save"
              width="100%"
              height="44px"
              loading={loading}
              padding="10px"
              color="#fff"
              onClick={handleSubmit}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default ConfigureStockPurificationModal;
